const lpTopMain = (() => {

  const pageLp = (document.getElementById("pageLp") != null);
  if (pageLp) {


    let secMain = document.getElementById('secMain');
    let jsVideo = secMain.querySelector('.js-video');
    let jsAudioBtn = secMain.querySelector('.js-audio-btn-box');


    jsAudioBtn.addEventListener("click", () => {
      if (jsVideo.muted) {
        jsVideo.volume = 0.08;
        jsVideo.muted = false;
        jsAudioBtn.classList.add('act')
      } else {
        jsVideo.muted = true;
        jsAudioBtn.classList.remove('act')
      }
    });



  }

})()
export default lpTopMain;